import modalMixin from '../../../mixins/_modal';
import deliveryTemplateSelecterComponent from './_template-selecter-component';
import deliveryTimeSettingsComponent from './_delivery-time-settings-component';
import deliveryDaySettingsComponent from './_delivery-day-settings-component';

/**
 * 送料設定の編集モーダル画面
 */
export default {
    name: 'DeliveryShippingDataEditer',
    template: '#delivery_shipping_data_editer_template',
    data() {
        return {
            // 新規登録の場合、配送方法テンプレートキーが代入される。
            add: null,
            // 編集中の配送設定データ箇所
            index: null,
            // 編集中の配送設定データ
            shipping: {},
        };
    },
    props: {
        // 配送データ一覧(設定名重複防止に使う)
        shippings: {
            type: Array,
            required: true
        }
    },
    mixins: [
        modalMixin,
    ],
    components: {
        // 配送方法テンプレート選択コンポーネント
        'delivery-template-selecter': deliveryTemplateSelecterComponent,
        // お届け時間帯設定コンポーネント
        'delivery-time-settings': deliveryTimeSettingsComponent,
        // お届け日設定コンポーネント
        'delivery-day-settings': deliveryDaySettingsComponent,
    },
    computed: {
        // 設定データが空か
        isEmptyShipping: function () {
            return (Object.keys(this.shipping).length === 0);
        },
        // すでに設定名が登録されているか
        isAlreadyPostageName: function () {
            const count = this.shippings.filter( (shipping, index) => {
                // 自身(編集中)の設定名は除く
                if (index == this.index) {
                    return false;
                }
                if (shipping.postage !== this.shipping.postage) {
                    return false;
                }
                return true;
            }).length;
            return (count > 0);
        },
    },
    emits: ['update-shipping'],
    methods: {
        // 設定データを初期化
        clearShipping: function () {
            this.shipping = {};
        },
        // 設定画面を開く
        show: function (index, shipping) {
            this.add = null;
            this.index = index;
            this.shipping = _.cloneDeep(shipping);
            this.open();
        },
        // 編集を保存する
        save: function (event) {
            console.log('編集を保存する');
            if (!event?.target?.form?.checkValidity()) {
                return;
            }
            event.preventDefault();

            if (this.isAlreadyPostageName) {
                swal('すでに設定されている配送方法の名称\n「' + this.shipping.postage + '」は使用できません');
                return;
            }
            this.emitUpdateShipping();
            this.close();
        },
        // モーダルを閉じたらindexを初期化
        closed: function () {
            this.index = null;
        },
        // ネストモーダルを開く
        openNestModal: function (ref) {
            this.$refs[ref].open();
        },

        // -------------------------
        // emit
        // -------------------------

        // 編集データを通知
        emitUpdateShipping: function() {
            console.log(this.shipping);
            this.$emit('update-shipping', this.index, this.shipping);
        }
    }
};
